// Same Firebase project and env variable names as the portal (src/firebase/config.js there), so one set of
// VUE_APP_FIREBASE_* values serves both apps. The web config is public; what protects sign-in is Firebase's
// authorized-domains list, which must include every dashboard host.
export const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MESURMENT_ID,
};
